export const msalConfig = {
	auth: {
		clientId: process.env.REACT_APP_MICROSOFT_CLIENTID,
		authority: `https://login.microsoftonline.com/${
			process.env.REACT_APP_TENANT_ID || 'common'
		}`,
		redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ['User.Read'],
};
